module.exports = __webpack_public_path__ + "static/media/personas-inactive.ab14d243.svg";